import React from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItemButton,
  ListItemText,
  Alert,
} from '@mui/material';
import { AppLayout } from '../components/layout/AppLayout';
import { Loader } from '../components/common/Loader';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../hooks/useAuth';
import { apiClient } from '../services/apiClient';
import { useNavigate } from 'react-router-dom';

interface Pet {
  id: string;
  name: string;
  species?: string;
  breed?: string;
}

export const VaccinationsPage: React.FC = () => {
  const { isMatched } = useAuth();
  const navigate = useNavigate();

  const { isLoading, error, data } = useApi<{ pets: Pet[] }>(
    () => apiClient.get('/webapp/vaccinations/pets'),
    { autoExecute: isMatched }
  );

  if (!isMatched) {
    return (
      <AppLayout title="Вакцинация">
        <Alert severity="info" sx={{ marginTop: 2 }}>
          Для просмотра данных о вакцинации необходимо сопоставить карту пациента.
          Это можно сделать в разделе{' '}
          <strong onClick={() => navigate('/profile')} style={{ cursor: 'pointer' }}>
            Мой кабинет
          </strong>
          .
        </Alert>
      </AppLayout>
    );
  }

  if (isLoading) {
    return (
      <AppLayout title="Вакцинация">
        <Loader message="Загрузка..." />
      </AppLayout>
    );
  }

  if (error) {
    return (
      <AppLayout title="Вакцинация">
        <Paper sx={{ padding: 2, backgroundColor: '#ffebee' }}>
          <Typography color="error">Ошибка: {error}</Typography>
        </Paper>
      </AppLayout>
    );
  }

  const pets = data?.pets || [];

  return (
    <AppLayout title="Вакцинация">
      <Box>
        {pets.length === 0 ? (
          <Paper sx={{ padding: 3, textAlign: 'center' }}>
            <Typography color="textSecondary">Данные о питомцах не найдены</Typography>
          </Paper>
        ) : (
          <Box>
            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: 2 }}>
              Выберите питомца для просмотра вакцинаций
            </Typography>
            <List>
              {pets.map((pet) => (
                <ListItemButton
                  key={pet.id}
                  component={Paper}
                  sx={{ marginBottom: 1, padding: 2 }}
                  onClick={() => navigate(`/vaccinations/${pet.id}`)}
                >
                  <ListItemText
                    primary={pet.name}
                    secondary={[pet.species, pet.breed].filter(Boolean).join(' · ')}
                  />
                </ListItemButton>
              ))}
            </List>
          </Box>
        )}
      </Box>
    </AppLayout>
  );
};

